import { SET_ALL_DATA_OF_ADMIN_USERS, SET_FILTERED_ADMIN_USERS, RESTE_ALL_ADMIN_USERS_DATA, SET_USERS_ADMIN_USERS, SET_PAGES_DATA_ADMIN_USERS, SET_SHOULD_UPDATE_ADMIN_USERS } from "../../../action/admin/users/type"

const initalState = {
    page: 0,
    total: 0,
    pages: 0,
    users: [],
    filtered: [],

    shouldUpdate: false,
}

const adminUsersReducer = (state = initalState, action) => {

    switch(action.type){

        case SET_ALL_DATA_OF_ADMIN_USERS :
            return {
                ...state,
                page: action.payload?.page,
                total: action.payload?.total,
                pages: action.payload?.pages,
                users: action.payload?.users,
                filtered: action.payload?.users 
            }

        case SET_USERS_ADMIN_USERS :
            return {
                ...state,
                users: action?.payload
            }

        case SET_FILTERED_ADMIN_USERS :
            return {
                ...state,
                filtered: action.payload,
            }

        case SET_PAGES_DATA_ADMIN_USERS :
            return {
                ...state,
                page: action?.payload?.page,
                pages: action?.payload?.pages,
                total: action?.payload?.total
            }

        case SET_SHOULD_UPDATE_ADMIN_USERS :
            return {
                ...state,
                shouldUpdate: action?.payload
            }

        case RESTE_ALL_ADMIN_USERS_DATA :
            return {
                ...state,
                ...initalState
            }

        default : 
            return state

    }

}

export default adminUsersReducer